/* ZOALIN_MOBILE_FOOTER_REMOVE_NEWSLETTER_20260719 */
/* ZOALIN_LOCALIZATION_LABELS_VISIBLE_20260719 */
/* ZOALIN_LOCALIZATION_SCROLL_FIX_20260719 */
/* ZOALIN_HOME_SERVICES_RUNTIME_COMPACT_20260719_1638 */
/* ZOALIN_MOBILE_HEADER_LOGO_MATCH_PDP_RUNTIME_20260719_1645 */
/* ZOALIN_PRIVACY_POLICY_PHONE_FIX_20260719 */
/* ZOALIN_POLICY_DUPLICATE_HEADING_FIX_20260719 */
/* ZOALIN_LOCALIZATION_HEADER_COMPACT_20260719 */
/* ZOALIN_POLICY_LINK_CACHE_BYPASS_20260719 */
/* ZOALIN_LOCALIZATION_US_MARKET_DOMAIN_GUARD_20260719 */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var timer = 0;
  var labelsMarker = 'ZOALIN_LOCALIZATION_LABELS_VISIBLE_20260719';
  var scrollMarker = 'ZOALIN_LOCALIZATION_SCROLL_FIX_20260719';
  var searchStyleId = 'zoalin-mobile-search-runtime-fix-20260719';
  var servicesStyleId = 'zoalin-home-services-runtime-compact-20260719';
  var headerLogoStyleId = 'zoalin-mobile-header-logo-match-pdp-runtime-20260719';
  var localizationHeaderStyleId = 'zoalin-localization-header-compact-runtime-20260719';
  var topTitleStyleId = 'zoalin-policy-and-privacy-top-title-remove-20260720';
  var unitedStatesFlagStyle = 'url("//cdn.shopify.com/static/images/flags/us.svg?width=48")';
  var unavailableCountryCodes = {};
  var policyPaths = {
    '/policies/privacy-policy': true,
    '/policies/terms-of-service': true,
    '/policies/shipping-policy': true,
    '/policies/refund-policy': true,
    '/policies/contact-information': true,
    '/policies/legal-notice': true
  };

  function normalizePolicyLinks() {
    document.querySelectorAll('a[href*="/policies/"]').forEach(function (link) {
      var href = link.getAttribute('href') || '';
      if (!href || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;

      var url;
      try {
        url = new URL(href, window.location.origin);
      } catch (error) {
        return;
      }

      if (url.origin !== window.location.origin || !policyPaths[url.pathname.replace(/\/$/, '')]) return;
      if (!url.searchParams.has('view')) url.searchParams.set('view', 'default');
      link.setAttribute('href', url.pathname + url.search + url.hash);
    });
  }

  function guardUnavailableLocalizationCountries() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-country-code]'), function (row) {
      var code = row.getAttribute('data-country-code') || '';
      if (!unavailableCountryCodes[code]) return;

      row.hidden = true;
      row.disabled = true;
      row.setAttribute('aria-hidden', 'true');
      row.setAttribute('aria-disabled', 'true');
      row.setAttribute('data-zoalin-country-unavailable', 'true');
      setImportant(row, {
        display: 'none',
        visibility: 'hidden',
        opacity: '0',
        height: '0',
        'min-height': '0',
        padding: '0',
        margin: '0',
        overflow: 'hidden',
        'pointer-events': 'none'
      });

      if (row.getAttribute('data-zoalin-unavailable-country-bound') !== '20260719') {
        row.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          row.hidden = true;
          setImportant(row, { display: 'none' });
        }, true);
        row.setAttribute('data-zoalin-unavailable-country-bound', '20260719');
      }
    });
    document.documentElement.setAttribute('data-zoalin-us-market-domain-guard', '20260719');
  }

  function ensureUnitedStatesLocalizationCountry() {
    Array.prototype.forEach.call(document.querySelectorAll('.zoalin-localization'), function (root) {
      var list = root.querySelector('.zoalin-localization__list');
      if (!list || root.querySelector('[data-country-code="US"]')) return;

      var empty = root.querySelector('[data-localization-empty]');
      var hasCurrency = !!root.querySelector('.zoalin-localization__currency');
      var item = document.createElement('button');
      item.type = 'button';
      item.className = 'zoalin-localization__country zoalin-localization__country--manual zoalin-localization__country--united-states' + (hasCurrency ? '' : ' zoalin-localization__country--single-currency');
      item.setAttribute('role', 'option');
      item.setAttribute('aria-selected', 'false');
      item.setAttribute('data-country-code', 'US');
      item.setAttribute('data-country-manual', 'true');
      item.setAttribute('data-country-search', 'united states us usa usd');
      item.innerHTML = '<span class="zoalin-localization__country-flag zoalin-localization__country-flag--us" style="background:#fff;background-image:' + unitedStatesFlagStyle + ';background-size:cover;background-position:center;background-repeat:no-repeat" aria-hidden="true"></span><span class="zoalin-localization__country-name">United States</span>' + (hasCurrency ? '<span class="zoalin-localization__currency">USD $</span>' : '') + '<span class="zoalin-localization__check" aria-hidden="true"><svg viewBox="0 0 18 18" fill="none"><path d="m3.75 9.25 3.15 3.15 7.35-7.35" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
      list.insertBefore(item, empty || null);
    });
  }

  function selectUnitedStatesLocalizationCountry(row) {
    if (!row) return;
    var root = row.closest('.zoalin-localization');
    if (!root) return;
    Array.prototype.forEach.call(root.querySelectorAll('[data-country-code]'), function (item) {
      item.classList.remove('is-current');
      item.setAttribute('aria-selected', 'false');
    });
    row.classList.add('is-current');
    row.setAttribute('aria-selected', 'true');
    var input = root.querySelector('[data-localization-country-input]');
    if (input) input.value = 'US';
    var trigger = root.querySelector('.zoalin-localization__trigger');
    var triggerLabel = trigger && trigger.querySelector('span:not(.zoalin-localization__flag):not(.zoalin-localization__caret)');
    var triggerFlag = root.querySelector('.zoalin-localization__flag');
    if (triggerLabel) triggerLabel.textContent = 'United States ' + String.fromCharCode(183) + ' USD';
    if (triggerFlag) {
      triggerFlag.removeAttribute('style');
      triggerFlag.classList.add('zoalin-localization__flag--us');
      setImportant(triggerFlag, { background: '#fff', 'background-image': unitedStatesFlagStyle, 'background-size': 'cover', 'background-position': '50% 50%', 'background-repeat': 'no-repeat' });
    }
    try {
      window.localStorage.setItem('zoalinManualCountryCode', 'US');
    } catch (error) {}
  }

  function restoreUnitedStatesLocalizationCountry() {
    ensureUnitedStatesLocalizationCountry();
    Array.prototype.forEach.call(document.querySelectorAll('[data-country-code="US"]'), function (row) {
      row.hidden = false;
      row.disabled = false;
      row.removeAttribute('hidden');
      row.removeAttribute('disabled');
      row.removeAttribute('aria-hidden');
      row.removeAttribute('aria-disabled');
      row.removeAttribute('data-zoalin-country-unavailable');
      row.removeAttribute('data-zoalin-unavailable-country-bound');
      setImportant(row, {
        display: 'grid',
        'grid-template-columns': '24px minmax(0, 1fr) 20px',
        'align-items': 'center',
        gap: '12px',
        visibility: 'visible',
        opacity: '1',
        height: 'auto',
        'min-height': '52px',
        padding: '0 8px',
        margin: '0',
        border: '0',
        'border-bottom': '1px solid #ece7df',
        'box-sizing': 'border-box',
        overflow: 'visible',
        'pointer-events': 'auto'
      });
      setImportant(row.querySelector('.zoalin-localization__country-flag'), {
        display: 'block',
        width: '24px',
        'min-width': '24px',
        height: '16px',
        'min-height': '16px',
        'border-radius': '2px',
        border: '1px solid rgba(17,17,17,.14)',
        background: '#fff',
        'background-image': unitedStatesFlagStyle,
        'background-size': 'cover',
        'background-position': '50% 50%',
        'background-repeat': 'no-repeat',
        'box-sizing': 'border-box'
      });
      try {
        if (window.localStorage.getItem('zoalinManualCountryCode') === 'US') {
          selectUnitedStatesLocalizationCountry(row);
        }
      } catch (error) {}
    });
    document.documentElement.setAttribute('data-zoalin-us-country-restored', '20260720');
  }

  function isNewsletterCopy(el) {
    if (!el || !el.textContent) return false;
    var text = el.textContent.replace(/\s+/g, ' ').trim();
    return (
      text.indexOf('SIGN UP FOR ZOALIN UPDATES') !== -1 ||
      text.indexOf('Receive early access to new modest dresses') !== -1
    );
  }

  function applyPrivacyPolicyPhoneFix() {
    if (!/\/policies\/privacy-policy\/?$/.test(window.location.pathname)) return;

    var root = document.querySelector('.shopify-policy__body');
    if (!root) return;

    var replacements = [
      /\+86\s*59\s*916282/g,
      /\+86\s*59916282/g
    ];
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    var node;

    while ((node = walker.nextNode())) {
      if (replacements.some(function (pattern) {
        pattern.lastIndex = 0;
        return pattern.test(node.nodeValue);
      })) {
        nodes.push(node);
      }
    }

    nodes.forEach(function (textNode) {
      var value = textNode.nodeValue;
      replacements.forEach(function (pattern) {
        value = value.replace(pattern, '+852 59 916282');
      });
      textNode.nodeValue = value;
    });

    if (nodes.length) {
      document.documentElement.setAttribute('data-zoalin-privacy-phone-fix', '20260719');
    }
  }

  function removeDuplicatePolicyHeading() {
    var body = document.querySelector('.shopify-policy__body .rte');
    if (!body || body.getAttribute('data-zoalin-policy-heading-fixed') === '20260719') return;

    var duplicatePolicyHeadings = {
      'terms of service': true,
      'shipping and delivery': true,
      'contact information': true,
      'legal notice': true,
      'refund policy': true,
      'returns and exchanges': true
    };
    var firstElement = body.firstElementChild;
    var firstText = (firstElement && firstElement.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();

    if (firstElement && /^(H1|H2)$/.test(firstElement.tagName) && duplicatePolicyHeadings[firstText]) {
      firstElement.remove();

      var nextHeading = body.firstElementChild;
      if (nextHeading && /^(H1|H2|H3)$/.test(nextHeading.tagName)) {
        nextHeading.style.setProperty('margin-top', '0', 'important');
        nextHeading.style.setProperty('padding-top', '0', 'important');
        nextHeading.style.setProperty('border-top', '0', 'important');
      }
    }

    body.setAttribute('data-zoalin-policy-heading-fixed', '20260719');
  }

  function removeNewsletterCopy() {
    if (!mq.matches) return;
    Array.prototype.forEach.call(document.querySelectorAll('footer [class*="__newsletter_text"]'), function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
    Array.prototype.forEach.call(document.querySelectorAll('footer rte-formatter, footer .text-block'), function (el) {
      if (isNewsletterCopy(el) && el.parentNode) el.parentNode.removeChild(el);
    });
  }

  function setImportant(el, props) {
    if (!el) return;
    Object.keys(props).forEach(function (name) {
      if (el.style.getPropertyValue(name) === props[name] && el.style.getPropertyPriority(name) === 'important') return;
      el.style.setProperty(name, props[name], 'important');
    });
  }

  function restoreLocalizationLabels() {
    if (!mq.matches) return;
    Array.prototype.forEach.call(document.querySelectorAll('.zoalin-localization'), function (root) {
      root.setAttribute('data-country-labels-visible', labelsMarker);
    });
    Array.prototype.forEach.call(document.querySelectorAll('.zoalin-localization__dialog'), function (dialog) {
      setImportant(dialog, { color: '#111' });
      setImportant(dialog.querySelector('.zoalin-localization__modal'), { background: '#fff', color: '#111' });
      setImportant(dialog.querySelector('.zoalin-localization__close'), { color: '#111' });
      Array.prototype.forEach.call(dialog.querySelectorAll('.zoalin-localization__close svg, .zoalin-localization__check, .zoalin-localization__check svg'), function (el) {
        setImportant(el, { color: '#111' });
      });
      Array.prototype.forEach.call(dialog.querySelectorAll('.zoalin-localization__country, [data-country-code]'), function (row) {
        var hasCurrency = !!row.querySelector('.zoalin-localization__currency');
        if (unavailableCountryCodes[row.getAttribute('data-country-code') || '']) return;
        setImportant(row, {
          display: row.hidden ? 'none' : 'grid',
          'grid-template-columns': hasCurrency ? '24px minmax(0, 1fr) auto 20px' : '24px minmax(0, 1fr) 20px',
          'align-items': 'center',
          gap: '12px',
          color: '#111',
          'font-size': '.88rem',
          'line-height': '1.25',
          'text-align': 'left'
        });
        Array.prototype.forEach.call(row.querySelectorAll('.zoalin-localization__country-name, .zoalin-localization__currency'), function (label) {
          var isCurrency = label.classList.contains('zoalin-localization__currency');
          setImportant(label, {
            display: 'block',
            visibility: 'visible',
            opacity: '1',
            width: 'auto',
            height: 'auto',
            'min-width': '0',
            'max-width': '100%',
            color: isCurrency ? '#6a655f' : '#111',
            'font-size': isCurrency ? '.78rem' : '.88rem',
            'font-weight': isCurrency ? '450' : '500',
            'line-height': '1.25'
          });
        });
      });
    });
  }

  function bindScrollPassthrough(list) {
    if (!list || list.getAttribute('data-localization-scroll-fix-bound') === scrollMarker) return;
    ['touchstart', 'touchmove', 'wheel'].forEach(function (eventName) {
      list.addEventListener(eventName, function (event) {
        event.stopPropagation();
      }, { passive: true });
    });
    list.setAttribute('data-localization-scroll-fix-bound', scrollMarker);
  }

  function restoreLocalizationScroll() {
    if (!mq.matches) return;
    Array.prototype.forEach.call(document.querySelectorAll('.zoalin-localization'), function (root) {
      var dialog = root.querySelector('.zoalin-localization__dialog');
      var modal = root.querySelector('.zoalin-localization__modal');
      var form = root.querySelector('.zoalin-localization__form');
      var list = root.querySelector('.zoalin-localization__list');
      if (!dialog || !modal || !form || !list) return;
      root.setAttribute('data-localization-scroll-fix', scrollMarker);
      setImportant(dialog, {
        overflow: 'hidden',
        'overscroll-behavior': 'contain',
        'touch-action': 'pan-y'
      });
      setImportant(modal, {
        display: 'flex',
        'flex-direction': 'column',
        height: '100dvh',
        'max-height': '100dvh',
        'min-height': '0',
        overflow: 'hidden',
        'overscroll-behavior': 'contain'
      });
      setImportant(form, {
        display: 'flex',
        'flex-direction': 'column',
        flex: '1 1 auto',
        height: 'auto',
        'min-height': '0',
        'max-height': 'none',
        overflow: 'hidden'
      });
      setImportant(list, {
        flex: '1 1 auto',
        height: 'auto',
        'min-height': '0',
        'max-height': 'none',
        overflow: 'hidden auto',
        'overflow-x': 'hidden',
        'overflow-y': 'auto',
        '-webkit-overflow-scrolling': 'touch',
        'overscroll-behavior': 'contain',
        'touch-action': 'pan-y',
        'padding-bottom': 'calc(40px + env(safe-area-inset-bottom))'
      });
      bindScrollPassthrough(list);
    });
  }

  function injectSearchLayoutFix() {
    if (!mq.matches || document.getElementById(searchStyleId)) return;
    var style = document.createElement('style');
    style.id = searchStyleId;
    style.textContent = [
      '/* ZOALIN_MOBILE_SEARCH_RUNTIME_FIX_20260719 */',
      '@media(max-width:749px){',
      '.search-modal__content .predictive-search-form__header-inner{display:grid!important;grid-template-columns:22px minmax(0,1fr) auto!important;align-items:center!important;gap:12px!important;}',
      '.search-modal__content .predictive-search__icon{grid-column:1!important;grid-row:1!important;width:22px!important;height:22px!important;justify-self:start!important;}',
      '.search-modal__content .search-input,.search-modal__content input[type="search"],.search-modal__content input[name="q"]{grid-column:2!important;grid-row:1!important;width:100%!important;min-width:0!important;}',
      '.search-modal__content .predictive-search__reset-button{grid-column:3!important;grid-row:1!important;min-width:28px!important;min-height:28px!important;margin:0!important;}',
      '.search-modal__content .zoalin-search-modal-logo{display:flex!important;width:fit-content!important;max-width:fit-content!important;min-height:30px!important;margin:26px auto 18px!important;padding:0!important;border:0!important;outline:0!important;align-items:center!important;justify-content:center!important;box-shadow:none!important;color:#111!important;font-family:Georgia,"Times New Roman",serif!important;font-size:1.5rem!important;font-weight:400!important;letter-spacing:.09em!important;line-height:1!important;text-decoration:none!important;}',
      '.search-modal__content .zoalin-search-modal-logo:before{content:"ZOALIN"!important;display:block!important;}',
      '.search-modal__content .zoalin-search-modal-logo img{display:none!important;}',
      '.search-modal__content .predictive-search-form__content-wrapper,.search-modal__content .zoalin-search-layout-20260707{margin-top:16px!important;}',
      '.search-modal__content .zoalin-search-quicklinks{display:none!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;overflow:hidden!important;visibility:hidden!important;}',
      '.search-modal__content .zoalin-search-quicklinks__group{min-width:0!important;margin:0!important;padding:18px 16px 17px!important;border:1px solid #ded8d0!important;background:#fffefa!important;}',
      '.search-modal__content .zoalin-search-quicklinks__links{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:12px 18px!important;min-width:0!important;}',
      '.search-modal__content .zoalin-search-quicklinks a{display:block!important;min-width:0!important;margin:0!important;font-size:clamp(.88rem,3.8vw,1rem)!important;line-height:1.25!important;white-space:normal!important;overflow-wrap:normal!important;word-break:normal!important;hyphens:none!important;}',
      '.search-modal__content .zoalin-search-products-20260712{margin:0!important;padding:0!important;border-top:0!important;}',
      '.search-modal__content .zoalin-search-products-20260712__header{display:none!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;overflow:hidden!important;visibility:hidden!important;}',
      '}',
      '@media(max-width:390px){.search-modal__content .predictive-search-form__content-wrapper,.search-modal__content .zoalin-search-layout-20260707{margin-top:14px!important}.search-modal__content .zoalin-search-quicklinks__links{gap:10px 14px!important}.search-modal__content .zoalin-search-quicklinks a{font-size:.84rem!important}}'
    ].join('');
    document.head.appendChild(style);
  }

  function injectHomeServicesCompact() {
    if (!mq.matches || document.getElementById(servicesStyleId)) return;
    var style = document.createElement('style');
    style.id = servicesStyleId;
    style.textContent = [
      '/* ZOALIN_HOME_SERVICES_RUNTIME_COMPACT_20260719_1638 */',
      '@media(max-width:749px){',
      'html body.template-index .zoalin-service-wrap{padding:18px 0 19px!important;background:#f6f3ee!important;border-top:1px solid rgba(226,220,211,.62)!important;border-bottom:1px solid rgba(226,220,211,.62)!important;}',
      'html body.template-index .zoalin-service-wrap .zoalin-service-grid{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;width:100%!important;max-width:none!important;min-height:0!important;margin:0!important;padding:0 22px!important;gap:0!important;background:transparent!important;border:0!important;align-items:stretch!important;}',
      'html body.template-index .zoalin-service-wrap .zoalin-service-grid__item{display:flex!important;flex-direction:column!important;justify-content:center!important;min-height:94px!important;padding:11px 20px 12px!important;background:transparent!important;border:0!important;box-shadow:none!important;}',
      'html body.template-index .zoalin-service-wrap .zoalin-service-grid__item:first-child{border-right:1px solid rgba(207,198,187,.48)!important;}',
      'html body.template-index .zoalin-service-wrap .zoalin-service-grid__item:nth-child(n+3){display:none!important;}',
      'html body.template-index .zoalin-service-wrap .zoalin-service-grid__item span{margin:0 0 8px!important;color:#8f877d!important;font-size:.61rem!important;line-height:1!important;letter-spacing:.075em!important;}',
      'html body.template-index .zoalin-service-wrap .zoalin-service-grid__item h3{margin:0 0 6px!important;color:#15120f!important;font-size:.86rem!important;line-height:1.14!important;}',
      'html body.template-index .zoalin-service-wrap .zoalin-service-grid__item p{max-width:18ch!important;margin:0!important;color:#6f675d!important;font-size:.73rem!important;line-height:1.32!important;}',
      '}',
      '@media(max-width:374px){html body.template-index .zoalin-service-wrap .zoalin-service-grid{padding:0 18px!important;}html body.template-index .zoalin-service-wrap .zoalin-service-grid__item{min-height:90px!important;padding:10px 17px 11px!important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function injectHeaderLogoMatchPdp() {
    if (!mq.matches || document.getElementById(headerLogoStyleId)) return;
    var style = document.createElement('style');
    style.id = headerLogoStyleId;
    style.textContent = [
      '/* ZOALIN_MOBILE_HEADER_LOGO_MATCH_PDP_RUNTIME_20260719_1645 */',
      '@media(max-width:749px){',
      'body,body.template-index,body.template-collection,body.template-search,body.template-page,body.template-cart,body.template-product{--zoalin-mobile-wordmark-width:90px!important;--zoalin-header-logo-width:90px!important;--zoalin-header-wordmark-width:90px!important;}',
      'html body #header-component .header-logo,html body #header-component .header-logo__link,html body #header-component .header-logo__text,html body #header-component .header-logo__wordmark,html body header-component .header-logo,html body header-component .header-logo__link,html body header-component .header-logo__text,html body header-component .header-logo__wordmark{width:90px!important;min-width:90px!important;max-width:90px!important;}',
      '/* ZOALIN_HOME_HEADER_CENTER_ALIGN_FIX_20260719 */',
      '/* ZOALIN_HOME_HEADER_CENTER_ALIGN_PURGE_20260719_2325 */',
      'html body.template-index{--zoalin-mobile-fixed-header-height:56px!important;--zoalin-mobile-header-side:24px!important;--zoalin-mobile-header-touch:44px!important;--zoalin-mobile-wordmark-width:90px!important;}',
      'html body.template-index .header-section,html body.template-index #header-component,html body.template-index header-component{height:var(--zoalin-mobile-fixed-header-height)!important;min-height:var(--zoalin-mobile-fixed-header-height)!important;max-height:var(--zoalin-mobile-fixed-header-height)!important;width:100vw!important;margin:0!important;padding:0!important;background:#fff!important;color:#000!important;transform:none!important;}',
      'html body.template-index #header-component .header-logo,html body.template-index #header-component .header-logo__link,html body.template-index #header-component .header-logo__text,html body.template-index #header-component .header-logo__wordmark,html body.template-index header-component .header-logo,html body.template-index header-component .header-logo__link,html body.template-index header-component .header-logo__text,html body.template-index header-component .header-logo__wordmark{position:fixed!important;left:50vw!important;top:calc(var(--zoalin-mobile-fixed-header-height)/2)!important;right:auto!important;bottom:auto!important;transform:translate(-50%,-50%)!important;width:var(--zoalin-mobile-wordmark-width)!important;min-width:var(--zoalin-mobile-wordmark-width)!important;max-width:var(--zoalin-mobile-wordmark-width)!important;height:auto!important;min-height:0!important;margin:0!important;padding:0!important;display:flex!important;align-items:center!important;justify-content:center!important;line-height:0!important;letter-spacing:0!important;z-index:1211!important;}',
      'html body.template-index #header-component summary.header__icon.header__icon--menu.header__icon--summary,html body.template-index header-component summary.header__icon.header__icon--menu.header__icon--summary,html body.template-index #header-component button.header-actions__action.button-unstyled[data-testid="cart-drawer-trigger"],html body.template-index header-component button.header-actions__action.button-unstyled[data-testid="cart-drawer-trigger"]{position:fixed!important;top:calc((var(--zoalin-mobile-fixed-header-height) - var(--zoalin-mobile-header-touch))/2)!important;width:var(--zoalin-mobile-header-touch)!important;min-width:var(--zoalin-mobile-header-touch)!important;max-width:var(--zoalin-mobile-header-touch)!important;height:var(--zoalin-mobile-header-touch)!important;min-height:var(--zoalin-mobile-header-touch)!important;max-height:var(--zoalin-mobile-header-touch)!important;margin:0!important;padding:0!important;display:flex!important;align-items:center!important;justify-content:center!important;line-height:0!important;transform:none!important;z-index:1212!important;}',
      'html body.template-index #header-component summary.header__icon.header__icon--menu.header__icon--summary,html body.template-index header-component summary.header__icon.header__icon--menu.header__icon--summary{left:var(--zoalin-mobile-header-side)!important;right:auto!important;}',
      'html body.template-index #header-component button.header-actions__action.button-unstyled[data-testid="cart-drawer-trigger"],html body.template-index header-component button.header-actions__action.button-unstyled[data-testid="cart-drawer-trigger"]{left:auto!important;right:var(--zoalin-mobile-header-side)!important;}',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  function injectLocalizationHeaderCompact() {
    if (!mq.matches || document.getElementById(localizationHeaderStyleId)) return;
    var style = document.createElement('style');
    style.id = localizationHeaderStyleId;
    style.textContent = [
      '/* ZOALIN_LOCALIZATION_HEADER_COMPACT_RUNTIME_20260719 */',
      '@media(max-width:749px){',
      'html body .zoalin-localization__dialog [data-country-code="US"]{display:grid!important;visibility:visible!important;opacity:1!important;height:auto!important;min-height:52px!important;margin:0!important;padding:0 8px!important;border-bottom:1px solid #ece7df!important;box-sizing:border-box!important;overflow:visible!important;pointer-events:auto!important;}',
      'html body .zoalin-localization__dialog[open] .zoalin-localization__header{align-items:center!important;gap:14px!important;min-height:72px!important;padding:17px 16px 14px!important;border-bottom:1px solid #e8e2d9!important;background:#fff!important;}',
      'html body .zoalin-localization__dialog[open] .zoalin-localization__heading-copy{display:block!important;flex:1 1 auto!important;min-width:0!important;margin:0!important;padding:0!important;}',
      'html body .zoalin-localization__dialog[open] .zoalin-localization__kicker,html body .zoalin-localization__dialog[open] .zoalin-localization__subtitle{display:none!important;visibility:hidden!important;width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;overflow:hidden!important;}',
      'html body .zoalin-localization__dialog[open] .zoalin-localization__title{display:block!important;max-width:calc(100vw - 92px)!important;margin:0!important;color:#111!important;font-family:var(--font-body--family,Arial,sans-serif)!important;font-size:20px!important;font-weight:720!important;letter-spacing:0!important;line-height:1.12!important;text-align:left!important;text-transform:none!important;}',
      'html body :is(#footer-group,.shopify-section-group-footer-group,footer) .footer-content.footer-content .zoalin-localization__dialog[open] .zoalin-localization__title{font-size:20px!important;line-height:1.12!important;}',
      'html body .zoalin-localization__dialog[open] .zoalin-localization__close{width:42px!important;height:42px!important;flex:0 0 42px!important;position:relative!important;z-index:4!important;border-color:#ded8cf!important;background:#fff!important;}',
      'html body .zoalin-localization__dialog[open] .zoalin-localization__search{margin:14px 16px 8px!important;font-size:16px!important;line-height:1.25!important;}',
      'html body .zoalin-localization__dialog[open] .zoalin-localization__search input,html body :is(#footer-group,.shopify-section-group-footer-group,footer) .footer-content.footer-content .zoalin-localization .zoalin-localization__dialog[open] .zoalin-localization__search input{height:50px!important;min-height:50px!important;border-color:#34312d!important;font-size:16px!important;line-height:1.25!important;-webkit-text-size-adjust:100%!important;}',
      'html body .zoalin-localization__dialog[open] .zoalin-localization__list{padding-top:2px!important;}',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  function ensurePrivacyPageTitle() {
    if (!/\/pages\/privacy-policy\/?$/.test(window.location.pathname)) return;

    var shell = document.querySelector('.zoalin-info-page-shell');
    if (!shell) return;

    shell.querySelectorAll('.zoalin-privacy-restored-title').forEach(function (title) {
      title.remove();
    });

    if (!document.getElementById('zoalin-privacy-page-title-restore-style-20260720')) {
      var style = document.createElement('style');
      style.id = 'zoalin-privacy-page-title-restore-style-20260720';
      style.textContent = [
        'html body.template-page #MainContent .zoalin-info-page-shell>.zoalin-privacy-restored-title{display:none!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;border:0!important;overflow:hidden!important;visibility:hidden!important;}',
        '@media(max-width:749px),(orientation:landscape) and (max-height:760px){html:has(meta[property="og:url"][content*="/pages/privacy-policy"]) body.template-page #MainContent>.shopify-section:has(.zoalin-info-page-shell){padding-top:0!important;}html:has(meta[property="og:url"][content*="/pages/privacy-policy"]) body.template-page #MainContent .zoalin-info-page-shell{padding-top:22px!important;}}'
      ].join('');
      document.head.appendChild(style);
    }
  }

  function injectTopTitleCleanup() {
    if (document.getElementById(topTitleStyleId)) return;

    var style = document.createElement('style');
    style.id = topTitleStyleId;
    style.textContent = [
      'html body #MainContent .shopify-policy__title{display:none!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;border:0!important;overflow:hidden!important;visibility:hidden!important;}',
      'html body #MainContent .shopify-policy__container{padding-top:22px!important;}',
      'html:has(meta[property="og:url"][content*="/pages/privacy-policy"]) body.template-page #MainContent .zoalin-info-page-shell>.zoalin-privacy-restored-title{display:none!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;border:0!important;overflow:hidden!important;visibility:hidden!important;}',
      '@media(max-width:749px),(orientation:landscape) and (max-height:760px){html:has(meta[property="og:url"][content*="/pages/privacy-policy"]) body.template-page #MainContent>.shopify-section:has(.zoalin-info-page-shell){padding-top:0!important;}html:has(meta[property="og:url"][content*="/pages/privacy-policy"]) body.template-page #MainContent .zoalin-info-page-shell{padding-top:22px!important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function schedule() {
    window.clearTimeout(timer);
    injectTopTitleCleanup();
    removeDuplicatePolicyHeading();
    applyPrivacyPolicyPhoneFix();
    injectSearchLayoutFix();
    injectHomeServicesCompact();
    injectHeaderLogoMatchPdp();
    injectLocalizationHeaderCompact();
    normalizePolicyLinks();
    guardUnavailableLocalizationCountries();
    restoreUnitedStatesLocalizationCountry();
    removeNewsletterCopy();
    ensurePrivacyPageTitle();
    restoreLocalizationScroll();
    restoreLocalizationLabels();
    timer = window.setTimeout(removeNewsletterCopy, 80);
    window.setTimeout(ensurePrivacyPageTitle, 80);
    window.setTimeout(restoreLocalizationScroll, 80);
    window.setTimeout(restoreLocalizationLabels, 80);
    window.setTimeout(function () {
      removeDuplicatePolicyHeading();
      applyPrivacyPolicyPhoneFix();
      guardUnavailableLocalizationCountries();
      restoreUnitedStatesLocalizationCountry();
      removeNewsletterCopy();
      ensurePrivacyPageTitle();
      restoreLocalizationScroll();
      restoreLocalizationLabels();
    }, 350);
    window.setTimeout(function () {
      removeNewsletterCopy();
      restoreUnitedStatesLocalizationCountry();
      ensurePrivacyPageTitle();
      restoreLocalizationScroll();
      restoreLocalizationLabels();
    }, 1200);
    window.setTimeout(function () {
      removeNewsletterCopy();
      restoreUnitedStatesLocalizationCountry();
      ensurePrivacyPageTitle();
      restoreLocalizationScroll();
      restoreLocalizationLabels();
    }, 2600);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  window.addEventListener('load', schedule);
  document.addEventListener('click', function (event) {
    var usRow = event.target && event.target.closest && event.target.closest('.zoalin-localization [data-country-code="US"]');
    if (usRow) {
      event.preventDefault();
      event.stopImmediatePropagation();
      selectUnitedStatesLocalizationCountry(usRow);
      var dialog = usRow.closest('.zoalin-localization__dialog');
      if (dialog && typeof dialog.close === 'function') dialog.close();
      return;
    }
    if (event.target && event.target.closest && event.target.closest('[data-localization-open], .zoalin-localization__trigger')) {
      window.setTimeout(restoreLocalizationScroll, 30);
      window.setTimeout(restoreLocalizationLabels, 30);
      window.setTimeout(restoreUnitedStatesLocalizationCountry, 30);
      window.setTimeout(restoreLocalizationScroll, 180);
      window.setTimeout(restoreLocalizationLabels, 180);
      window.setTimeout(restoreUnitedStatesLocalizationCountry, 180);
    }
  }, true);
  if (mq.addEventListener) mq.addEventListener('change', schedule);
  else if (mq.addListener) mq.addListener(schedule);

})();
